const iconButtons = [
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_css post__icon_location_new-post-popup",
    buttonValue: "css",
    name: "icon",
    labelText: "",
    _id: "ib0",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_js post__icon_location_new-post-popup",
    buttonValue: "js",
    name: "icon",
    labelText: "",
    _id: "ib1",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_typescript post__icon_location_new-post-popup",
    buttonValue: "typescript",
    name: "icon",
    labelText: "",
    _id: "ib2",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_markup post__icon_location_new-post-popup",
    buttonValue: "markup",
    name: "icon",
    labelText: "",
    _id: "ib3",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_react post__icon_location_new-post-popup",
    buttonValue: "react",
    name: "icon",
    labelText: "",
    _id: "ib4",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_design post__icon_location_new-post-popup",
    buttonValue: "design",
    name: "icon",
    labelText: "",
    _id: "ib5",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_illustrations post__icon_location_new-post-popup",
    buttonValue: "illustrations",
    name: "icon",
    labelText: "",
    _id: "ib6",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_tests post__icon_location_new-post-popup",
    buttonValue: "tests",
    name: "icon",
    labelText: "",
    _id: "ib7",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_list post__icon_location_new-post-popup",
    buttonValue: "list",
    name: "icon",
    labelText: "",
    _id: "ib8",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_music post__icon_location_new-post-popup",
    buttonValue: "music",
    name: "icon",
    labelText: "",
    _id: "ib9",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_book post__icon_location_new-post-popup",
    buttonValue: "book",
    name: "icon",
    labelText: "",
    _id: "ib10",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_photo post__icon_location_new-post-popup",
    buttonValue: "photo",
    name: "icon",
    labelText: "",
    _id: "ib11",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_photobook post__icon_location_new-post-popup",
    buttonValue: "photobook",
    name: "icon",
    labelText: "",
    _id: "ib12",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_mappin post__icon_location_new-post-popup",
    buttonValue: "mappin",
    name: "icon",
    labelText: "",
    _id: "ib13",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_layout post__icon_location_new-post-popup",
    buttonValue: "layout",
    name: "icon",
    labelText: "",
    _id: "ib14",
  },

  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_journey post__icon_location_new-post-popup",
    buttonValue: "journey",
    name: "icon",
    labelText: "",
    _id: "ib15",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_backpack post__icon_location_new-post-popup",
    buttonValue: "backpack",
    name: "icon",
    labelText: "",
    _id: "ib16",
  },
  {
    class:
      "new-post__radio-btn_type_icon post__icon post__icon_type_cat post__icon_location_new-post-popup",
    buttonValue: "cat",
    name: "icon",
    labelText: "",
    _id: "ib17",
  },
];

export default iconButtons;
